import {
  FieldFile,
  FieldFormArea,
  FieldRadio,
  FieldRadioGroup,
  FieldText,
  FieldTextArea,
  FieldButton,
  FieldCheckBox,
  FieldCheckBoxGroup,
  FieldHidden,
} from "components/voc";
import { FieldSetInputProps } from "components/voc";

type FieldsProps = {
  inputs: FieldSetInputProps[];
};

type FieldProps = {
  input: FieldSetInputProps;
};

const Field = ({ input }: FieldProps) => {
  if (input.formGroup) {
    switch (input.formGroup.formType) {
      default:
        return <></>;
      case "radio":
        return (
          <FieldRadioGroup>
            {input.formGroup.form?.map(({ valid, ...jel }, jidx) => (
              <FieldRadio key={jidx} {...jel} />
            ))}
          </FieldRadioGroup>
        );
      case "checkbox":
        return (
          <FieldCheckBoxGroup>
            {input.formGroup.form?.map(({ valid, ...jel }, jidx) => (
              <FieldCheckBox key={jidx} {...jel} />
            ))}
          </FieldCheckBoxGroup>
        );
    }
  } else {
    switch (input.type) {
      default:
        return <></>;
      case "text":
      case "number":
      case "email":
        return <FieldText {...input} />;
      case "hidden":
        return <FieldHidden {...input} />;
      case "file":
        return <FieldFile {...input} />;
      case "button":
        const buttonProps = {
          id: input.id,
          name: input.name,
          className: input.className,
          children: input.children,
          onClick: input.buttonClick,
        };
        return <FieldButton {...buttonProps} />;
      case "textarea":
        const textAreaProps = {
          id: input.id,
          name: input.name,
          className: input.className,
          placeholder: input.placeholder,
        };
        return <FieldTextArea {...textAreaProps} />;
    }
  }
};

const Fields = ({ inputs }: FieldsProps) => {
  return (
    <>
      {inputs.map(({ valid, fieldLabelText, mandatory, noti, cascadeField, ...el }, idx) => {
        let cascadeFieldValue: React.InputHTMLAttributes<HTMLInputElement>["value"];
        if (cascadeField) {
          cascadeFieldValue = inputs.find((x) => x.name === cascadeField)?.value;
        }
        return (
          <FieldFormArea
            key={idx}
            fieldLabelText={fieldLabelText}
            mandatory={mandatory}
            noti={noti}
            style={{ display: `${cascadeField && !cascadeFieldValue ? "none" : ""}` }}
          >
            <Field input={el} />
            {el.type !== "button" && el.children}
          </FieldFormArea>
        );
      })}
    </>
  );
};

export default Fields;
